import { Textarea } from '@/components/catalyst/textarea'
import { forwardRef } from 'react'

interface FormTextareaProps {
  name?: string
  value?: string | null
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  rows?: number
  disabled?: boolean
  resizable?: boolean
  className?: string
}

const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(function FormTextarea(
  { value, resizable = false, ...props },
  ref
) {
  return <Textarea ref={ref} value={value ?? ''} resizable={resizable} {...props} />
})

export default FormTextarea
